<template>
  <div class="g-container g-container-bg">
    <div class="com-detail-hd">
      <div class="com-hd-inner" :style="{backgroundImage:`url(${backgroundImage})`}">
        <div class="com-hd-info">
          <div class="com-hd-face">
            <img :src="trace.proIcon" alt />
          </div>
          <div class="com-hd-name">
            <div class="hd-bottom-td">
              <div class="hd-name-row">{{trace.proName}}</div>
              <!--今日信息-->
              <!--<div class="hd-name-row">-->
              <!--<span>今天</span>-->
              <!--<span>2017年3月18日</span>-->
              <!--<span>星期三</span>-->
              <!--<span>天气：晴</span>-->
              <!--</div>-->
            </div>
          </div>
        </div>
        <!--右侧操作-->
        <div class="com-hd-handle">
          <div class="hd-bottom-td">
            <!-- <span class="cm-sign-btn">签到详情</span> -->
            <h-qrcode></h-qrcode>
          </div>
        </div>
      </div>
    </div>
    <div class="m-container m-width">
      <!--面包屑-->
      <div class="crumbs-box">
        <router-link tag="a" class="c-crumbs" :to="{name:'default'}">首页</router-link>
        <span class="c-sep">&gt;</span>
        <router-link tag="a" class="c-crumbs" :to="{name:'caseIndex'}">案例库</router-link>

        <span class="c-sep">&gt;</span>
        <router-link
          tag="a"
          class="c-crumbs"
          :to="{name:'caseDetal',params:{id:this.$route.params.id}}"
        >{{trace.proName}}</router-link>
        <span class="c-sep">&gt;</span>
        <span class="c-current">项目回顾</span>
      </div>
      <!--项目回顾-->
      <div class="project-trace-content">
        <div class="m-second-tabs">
          <span :class="{'active':params.type=='all'}" @click="getData('all')">全部</span>
          <span class="u-line">|</span>
          <span :class="{'active':params.type=='qe'}" @click="getData('qe')">QE报告</span>
          <span class="u-line">|</span>
          <span :class="{'active':params.type=='report'}" @click="getData('report')">周报</span>
        </div>
        <div class="trace-timeline">
          <!--全部-->
          <div class="time-line-box">
            <div class="time-line-row" v-for="(item,index) in projects" :key="index">
              <div class="time-line-date">{{item.year}}</div>
              <div class="time-line-info">
                <i class="time-number">{{item.day}}</i>
                <div class="time-line-title">
                  <b>{{item.title}}</b>
                  <span class="t-tags-icon">{{item.postType}}</span>
                  <span class="see-count-number">
                    <i class="n-small-icon eye-icon"></i>
                    <span>{{item.hits}}人看过</span>
                  </span>
                </div>
                <div class="time-line-tipper">
                  <p v-html="item.content"></p>
                  <p>
                    <span class="pr-20">安全状况:{{item.safeState}}</span>
                    <span>天气:{{item.weather}}</span>
                  </p>
                </div>
                <div class="cp-column big-pic hover-scale">
                  <div class="cp-item" v-for="(pic,i) in item.images" :key="i">
                    <img :src="pic" alt />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../../html/components/banner/banner.scss';
import '../../../../html/components/crumbs/crumbs.scss';
import '../../../../html/components/detailHd/detailHd.scss';
import '../../../../html/components/tabs/tabs.scss';
import '../../../../html/components/picture/picture.scss';
import '../../../../html/pages/cases/trace/trace.scss';

import hQrcode from '../../../../components/h-qrcode/h-qrcode';

import { getProjectEnd,getWeather } from '../../../../api/index';
export default {
  name: 'trace',
  components: {
    hQrcode
  },
  data() {
    return {
      // title: this.$route.query.title,
      params: {
        id: this.$route.params.id,
        type: 'all',
        index: 0,
        size: 10000
      },
      projects: [],
      trace: {},
      backgroundImage: '',
      sunnyImage: './gif/sunny.gif',
      hotImage: './gif/hot.gif',
      rainImage: './gif/rain.gif',
      snowImage: './gif/snow.gif',
      cloudyImage: './gif/cloudy.gif',
      fogImage: './gif/fog.gif',
    };
  },
  methods: {
    //获取数据
    async getData(type) {
      this.params.type = type;
      let res = await getProjectEnd(this.params);
      if (res.Type == 'Success') {
        this.trace = res.Data;
        this.projects = res.Data.projectEnd;
        this.projects.forEach(item => {
          item.year =
            item.createdTime.split(' ')[0].split('-')[0] +
            '.' +
            item.createdTime.split(' ')[0].split('-')[1];
          item.day = item.createdTime.split(' ')[0].split('-')[2];
          // console.log(item.year, item.day);
        });

      } else {
        this.$layer.alert(res.Content);
      }
    },
    async getWeather() {
      let res = await getWeather({
        city: '苏州'
      });
      if (res.Type == 'Success') {
        this.weather = res.Data;
        switch (this.weather) {
          case "晴":
            this.backgroundImage = this.sunnyImage;
            break;
          case "高温":
            this.backgroundImage = this.hotImage;
            break;
          case "雨":
            this.backgroundImage = this.rainImage;
            break;
          case "雪":
            this.backgroundImage = this.snowImage;
            break;
          case "雾":
            this.backgroundImage = this.fogImage;
            break;
          case "阴":
            this.backgroundImage = this.cloudyImage;
            break;
        }
      }
    },
  },
  created() {
    this.getData('all');
    this.getWeather();
  }
};
</script>

<style>
</style>
